<template>
  <div class="subscriber-app" :class="{ open }" @click="open = false">
    <div class="subscriber-inside basket-like" @click.stop="() => {}">
      <div v-if="!success">
        <div
          class=""
          style="
            text-align: center;
            border-bottom: 1px solid black;
            padding: 1em 2em;
          "
        >
          <h3>{{ form.abo_name }} ({{ form.abo_price }}€ / m.)</h3>
          <p style="max-width: 60ch; margin: auto">
            Merci de remplir ce formulaire de demande d'abonnement. Nous vous
            contacterons sous peu pour mettre en place votre prélèvement.
          </p>
        </div>
        <div class="coords_form">
          <div class="form_side">
            <label class="required"
              ><input
                type="text"
                v-model="form.first_name"
                name="first_name"
                required
                autocomplete
                placeholder="Prénom"
              />
            </label>
            <label class="required"
              ><input
                type="email"
                v-model="form.email"
                name="email"
                required
                autocomplete
                placeholder="e-mail"
              />
            </label>
            <label class="required"
              ><input
                type="phone"
                v-model="form.phone"
                name="phone"
                required
                autocomplete
                placeholder="téléphone"
              />
            </label>
            <label class="required"
              ><input
                type="text"
                v-model="form.city"
                name="city"
                required
                autocomplete
                placeholder="ville"
              />
            </label>
          </div>
          <div class="form_side">
            <label class="required"
              ><input
                type="text"
                v-model="form.last_name"
                name="last_name"
                required
                autocomplete
                placeholder="Nom"
              />
            </label>
            <label class="required"
              ><input
                type="email"
                v-model="form.email_confirm"
                name="email_confirm"
                required
                autocomplete
                placeholder="confirmez votre e-mail"
              />
            </label>
            <label class="required"
              ><input
                type="text"
                v-model="form.address"
                name="address"
                required
                autocomplete
                placeholder="adresse"
              />
            </label>
            <label class="required"
              ><input
                type="text"
                v-model="form.postcode"
                name="postcode"
                required
                autocomplete
                placeholder="code postal"
              />
            </label>
          </div>
        </div>
        <div
          class=""
          style="
            text-align: center;
            border-bottom: 1px solid black;
            padding: 1em 2em;
          "
        >
          <h3>Durée souhaitée de votre abonnement</h3>
        </div>
        <div
          style="display: flex; padding: 1em; border-bottom: 1px solid black"
        >
          <label class="fakeradio" for="duration-1"
            ><input
              type="radio"
              id="duration-1"
              name="duration"
              v-model="form.abo_duration"
              :value="1"
            /><span class="radio"></span> 1 mois</label
          >
          <label class="fakeradio" for="duration-3"
            ><input
              type="radio"
              id="duration-3"
              name="duration"
              v-model="form.abo_duration"
              :value="3"
            /><span class="radio"></span> 3 mois</label
          >
          <label class="fakeradio" for="duration-6"
            ><input
              type="radio"
              id="duration-6"
              name="duration"
              v-model="form.abo_duration"
              :value="6"
            /><span class="radio"></span> 6 mois</label
          >
          <label class="fakeradio" for="duration-12"
            ><input
              type="radio"
              id="duration-12"
              name="duration"
              v-model="form.abo_duration"
              :value="12"
            /><span class="radio"></span> 1 an</label
          >
        </div>
        <div>
          <div class="payment-buttons">
            <button
              style="flex: 0 0 100%"
              @click="submit"
              :class="{ disabled: sending || invalid }"
            >
              Envoyer votre demande d'abonnement
            </button>
          </div>
        </div>
      </div>
      <div v-if="success && !error" style="display: flex; height: 100%; align-items: center; text-align: center;">
        <h3 style="margin:auto">Merci pour votre demande ! Cette fenêtre va se refermer.</h3>
      </div>
      <div v-if="error">
        <h3>Une erreur s'est produite. Merci de vérifier le formulaire.</h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Subscriber",
  data() {
    return {
      open: false,
      sending: false,
      error: false,
      success: false,
      form: {
        last_name: "",
        first_name: "",
        abo_name: "",
        abo_duration: 3,
        abo_price: 0,
        address: "",
        phone: "",
        email: "",
        email_confirm: "",
        city: "",
        postcode: "",
      },
    };
  },
  computed: {
    invalid() {
      const f = this.form;
      return (
        !f.last_name ||
        !f.first_name ||
        !f.address ||
        !f.phone ||
        !f.email ||
        !(f.email.trim() === f.email_confirm.trim()) ||
        !f.city ||
        !f.postcode
      );
    },
  },
  methods: {
    submit() {
      if (this.sending) return;
      this.sending = true;
      axios
        .post("/subscribe", { payload: this.form })
        .then(() => {
          this.success = true;
          this.error = false;
          this.sending = false;
          setTimeout(() => {
            this.open = false;
          }, 2000);
        })
        .catch(() => {
          this.error = true;
          this.success = false;
          this.sending = false;
        });
    },
  },
  mounted() {
    window.subscribe("SUBSCRIBTION", (a) => {
      this.form.abo_name = a.title;
      this.form.abo_price = a.price;
      this.open = true;
    });
  },
};
</script>

<style lang="scss">
.subscriber-app {
  display: none;
  z-index: 3;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  &.open {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .subscriber-inside {
    width: calc(100% - 32px);
    max-width: 720px;
    background: white;
    height: calc(100% - 32px);
    max-height: 720px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    overflow-y: scroll;
  }
}
</style>